import '../static/major/scss/profile.scss';
import '../static/major/js/media-gallery';
import '../static/major/js/libs/jquery.pretty-photo.modified';
import '../static/major/js/saved-list';
import '../static/major/js/tabs';
import 'waypoints/lib/jquery.waypoints';
import '../static/major/js/libs/waypoints/jquery.waypoints.config';

import 'readmore-js/readmore';
import 'bootstrap/js/src/carousel';
import 'bootstrap/js/src/collapse';
import './profile-pages/product-collapsible-list';
import './react-components/send-text/index.jsx';
import './react-components/customer-rating.jsx';
import './react-components/customer-rating-bar.jsx';

import {trackStoreLocatorClickThrough} from "./analytics/store-locator";
import { initCashbackPromoButtons } from "./react-components/promo/buttons/cashback.jsx";
import { renderPromoButton } from "./react-components/promo/buttons/general.jsx";
import {initHelpfulnessVotes} from "./react-components/helfulness-votes";
import {renderPhoneButton} from "./react-components/phone-button";
import {renderStarComponent} from "./react-components/star-rating";

import {
  initializeMatchDataCollapsible,
  initializeMatchDataTitlesAdjustments,
  setUpBrandTransitions,
  setUpDrawer,
  setUpEvaluationBanner,
  setUpGallery,
  setUpSly,
  setUpTableSorter,
} from "./profile-pages/effects";

import {handleQuickViewClick} from "./profile-pages/quick-view";


window.initializeMatchDataCollapsible = initializeMatchDataCollapsible;
window.handleQuickViewClick = handleQuickViewClick;
window.initializeMatchDataTitlesAdjustments = initializeMatchDataTitlesAdjustments;

document.addEventListener('DOMContentLoaded', function (e) {

  $("#profile-pitch").readmore({collapsedHeight: 75});
  $('.model-counter').hide();

  setUpGallery();
  setUpDrawer();
  setUpBrandTransitions();
  setUpTableSorter();
  setUpEvaluationBanner();
  initCashbackPromoButtons();
  renderPromoButton();
  renderPhoneButton();
  trackStoreLocatorClickThrough();
  initHelpfulnessVotes();
  renderPhoneButton();
  renderStarComponent();
  setUpSly();
  initializeMatchDataCollapsible(e);
  initializeMatchDataTitlesAdjustments()
});
